import React from 'react';
import { Trophy, Users, Compass, Rocket, Briefcase, Mic, Award, GraduationCap, Store, Monitor } from 'lucide-react';

const Services = () => {
  const servicesList = [
    { title: "Corporate Cricket & Sports Days", icon: <Trophy size={40} className="text-gold mb-4" />, desc: "Organizing engaging sports tournaments and team-building athletic events." },
    { title: "Annual Days & Employee Engagement", icon: <Users size={40} className="text-gold mb-4" />, desc: "Memorable annual celebrations and activities to boost employee morale." },
    { title: "Team Outings & Offsites", icon: <Compass size={40} className="text-gold mb-4" />, desc: "Curated destination getaways to foster team bonding and strategic planning." },
    { title: "Product Launches", icon: <Rocket size={40} className="text-gold mb-4" />, desc: "High-impact launch events to introduce your new offerings to the market." },
    { title: "Dealer & Distributor Meets", icon: <Briefcase size={40} className="text-gold mb-4" />, desc: "Professional gatherings to align, train, and celebrate your channel partners." },
    { title: "Conferences & Seminars", icon: <Mic size={40} className="text-gold mb-4" />, desc: "Seamlessly managed professional events for knowledge sharing and networking." },
    { title: "Award Nights", icon: <Award size={40} className="text-gold mb-4" />, desc: "Glamorous recognition ceremonies to celebrate top performers and achievements." },
    { title: "Campus Placement Events", icon: <GraduationCap size={40} className="text-gold mb-4" />, desc: "Bridging the gap with smoothly executed campus recruitment and transition events." },
    { title: "Exhibition Stall Execution", icon: <Store size={40} className="text-gold mb-4" />, desc: "End-to-end design and fabrication of eye-catching exhibition booths." },
    { title: "Hybrid & Virtual Webinars", icon: <Monitor size={40} className="text-gold mb-4" />, desc: "Flawless technical execution for digital and hybrid corporate communications." }
  ];

  return (
    <section id="services" className="py-20 bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-gold text-sm font-bold tracking-widest uppercase mb-2">Our Services</h3>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-serif">What We Offer</h2>
          <div className="w-24 h-1 bg-gold mx-auto"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {servicesList.map((service, index) => (
            <div key={index} className="bg-zinc-900 p-8 border border-zinc-800 hover:border-gold transition duration-300 text-center group">
              <div className="flex justify-center transform group-hover:-translate-y-2 transition duration-300">{service.icon}</div>
              <h3 className="text-xl font-bold mb-3 font-serif">{service.title}</h3>
              <p className="text-gray-400 leading-relaxed text-sm">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;